// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/collapse/style/index.less
// module id = 922
// module chunks = 1